import { createFileRoute } from '@tanstack/react-router'
import { ParametersMenuWidget } from '@/widgets/parameters-menu-widget'

export const Route = createFileRoute(
  '/_auth/canteen/menu-settings/catalog-menu/details/$menuCardId/parameters'
)({
  component: RouteComponent,
})

function RouteComponent() {
  return <ParametersMenuWidget />
}
